import { graphql } from '@api/gql';

export const INVENTORY_FILTER_OPTIONS_FRAGMENT = graphql(/* GraphQL */ `
  fragment InventoryFilterOptions_Fragment on InventoryFilterOptions {
    key
    label
    secondary
    permissionsCount
    resourcesCount
    icon
  }
`);

export const inventoryFilterOptionsDocument = graphql(/* GraphQL */ `
  query InventoryFilterOptions($filter: InventoryFilterOptionsInput!, $pagination: PaginationInput) {
    inventoryFilterOptions(filter: $filter, pagination: $pagination) {
      hasMore
      data {
        ...InventoryFilterOptions_Fragment
      }
    }
  }
`);
